import * as uf from '%/functions';
import { Link } from 'react-router-dom';
import AsyncImage from '@/AsyncImage';
import { useContext } from 'react';
import ShopContext from '../hooks/context/ShopContext';

const ProductCard = (props) => {

  const {
    id,
    title = 'Whelen Legacy LED Light Bar, DUO Front BLUE/WHITE, DUO Rear BLUE/AMBER, Front Flood Feature, WeCanX, 48 inches, Clear Lens, EB8SP3B',
    categories,
    description = '',
    price = 229900,
    inventory = {},
    free_shipping,
    brand = {},
    product_images = [],
    msrp,
    thumbnail = {}

  } = props;


  const {
    auth
  } = useContext(ShopContext);

  const discountFactor = (auth.customer_group && auth.customer_group?.discount_type == 'percentage') ? (1 - auth.customer_group.discount / 100) : 1

  return (
    <div
      class="prod-item ng-scope">

      <article
        class="card ">
        <figure
          class="card-figure">
          <div
            class="prod-image has-img-swap"
          >
            <a
              href={`/products/${id}/view`}
              // href="//danasafetysupply.com/whelen-legacy-led-light-bar-solo-front-duo-rear-blue-front-blue-amber-rear-wecanx-48-inches-clear-lens-eb8sp3b/" intellisuggest=""
              class="ng-scope img-container" >
              {
                product_images[0]?.url ?
                  <AsyncImage
                    path={product_images[0]?.url}
                    imageClassName='card-image'
                  />
                  :
                  <img
                    class="card-image ng-scope"
                    alt="Whelen Legacy LED Light Bar, DUO Front BLUE/WHITE, DUO Rear BLUE/AMBER, Front Flood Feature, WeCanX, 48 inches, Clear Lens, EB8SP3B"
                    src="https://dss-assets.s3.amazonaws.com/images/DSS-3D-BW.webp" />
              }
              {
                product_images[1]?.url ?
                  <AsyncImage
                    path={product_images[1]?.url}
                    alt={title}
                    imageClassName='card-image img-swap'
                  />
                  :
                  (
                    (thumbnail?.url || product_images[0]?.url) ?
                      <AsyncImage
                        alt={title}
                        path={thumbnail?.url || product_images[0]?.url}
                        imageClassName='card-image img-swap'
                      />
                      :
                      <img
                        class="card-image img-swap ng-scope"
                        alt="Whelen Legacy LED Light Bar, DUO Front BLUE/WHITE, DUO Rear BLUE/AMBER, Front Flood Feature, WeCanX, 48 inches, Clear Lens, EB8SP3B"
                        src="https://dss-assets.s3.amazonaws.com/images/DSS-3D-BW.webp" />
                  )
              }

            </a>
            {
              !!inventory.quantity &&
              <div
                class="ss-stock-badge ng-scope"
              >
                <div>
                  <span
                    class="ng-binding ng-scope"> {inventory.quantity}</span>
                  <div
                    class="ng-binding">In Stock
                  </div>
                </div>
              </div>
            }

          </div>
          {
            free_shipping > 0 &&
            <div
              class="free-shipping-badge ng-scope">Free Shipping!
            </div>
          }
          <div
            class="ss-swatches" >
          </div>
          <figcaption
            class="prod-desc">
            <h4
              class="prod-name">
              <a
                href={`/products/${id}/view`}
                class="ng-binding" ss-ps=""

              >
                {title ||
                  `
                  Whelen Legacy LED Light Bar, DUO Front BLUE/WHITE, DUO Rear BLUE/AMBER, Front Flood Feature, WeCanX, 48 inches, Clear Lens, EB8SP3B
                  `
                }
              </a>
            </h4>

            <div
              class="star_container 104057">
              <div
                class="group-stars">
                <span
                  class="off"></span>
                <span
                  class="off"></span>
                <span
                  class="off"></span>
                <span
                  class="off"></span>
                <span
                  class="off"></span>
                <span
                  class="ind_cnt low"></span>
              </div>
            </div>
            <div class="prod-price" >
              {
                (msrp && msrp != price) ?
                  <div
                    class="price-section price-section--withoutTax ng-scope">
                    <span
                      style={{
                        opacity: 0.5,
                        fontSize: 16,
                        position: 'relative',
                        textDecoration: 'line-through',
                        textAlign: 'left'
                      }}
                      class="price price--withoutTax ng-binding">{uf.determinePrice(msrp)}</span>
                  </div>
                  : null
              }
              <div
                style={{ position: 'absolute' }}
                class="price-section price-section--withoutTax ng-scope">
                <span
                  class="price price--withoutTax ng-binding">
                  {(price || msrp) > 0 ? uf.determinePrice(auth.customer_group?.id ? msrp * discountFactor : price || msrp) : ''}
                </span>
              </div>
            </div>
            <div
              class="btnAbs">
              <a
                href={`/products/${id}/view`}
                class="btn btn-oranges btnATC ssATC hasopt ng-scope" data-product-id="104057" intellisuggest="" ss-ps="">							<i
                  class="icon-cart">
                  <svg>
                    <use xlinkHref="#shopping-bag-add"></use>
                  </svg>
                </i>See Option
              </a>
            </div>
            {/* <a href="/wishlist.php?action=add&amp;product_id=104057"
              class="btnWL WLproductList" intellisuggest="" ss-ps="">
              <i
                class="fa fa-heart"></i>
              <span>Add to Wish list</span>
            </a> */}
          </figcaption>
        </figure>
      </article>
    </div>
  )
}
export default ProductCard;